import { authInstance } from '../firebase';
import { deleteLocalAndSessionStorageAndCookies } from './cache';
import * as segment from './segment';

export const getDisplayName = user => {
  return user.userName || user.displayNAme || user.username;
};

export const getAvaName = user => {
  return user.avaName;
};

export const getDisplayId = (user, t) => {
  if (user.emails) {
    return Array.from(Object.values(user.emails))[0];
  }
  if (user.phoneNumber) {
    return user.phoneNumber;
  }
  if (user.accountType === 'Temporary') {
    return t('temporaryAccount');
  }
  return user.uid || user.id;
};

export const getUserColor = username => {
  if (!username) {
    return 'grey';
  }
  let hash = 0;
  username.split('').forEach(c => {
    // eslint-disable-next-line
    hash = c.charCodeAt(0) + ((hash << 5) - hash);
  });
  const h = hash % 360;
  // eslint-disable-next-line
  return 'hsl(' + h + ', ' + 50 + '%, ' + 50 + '%)';
};

export const isDevMode = (currentPlatform, features, backends) => {
  if (features['dev-mode']) {
    return true;
  }

  switch (currentPlatform) {
    case 'web':
      return localStorage.getItem('avaBackendUrl') === backends.production.url;
    case 'scribe':
      return true;
    default:
      return false;
  }
};

export const logoutAndClean = async () => {
  if (authInstance.currentUser && authInstance.currentUser.isAnonymous) {
    await authInstance.currentUser.delete();
  }
  // track('Sign out', {}, 'Web');
  segment.track('Signed Out');
  segment.reset();
  await authInstance.signOut();
  deleteLocalAndSessionStorageAndCookies();
};
